import $ from 'jquery';
import { colSizes, getFormatNameAndOrientration } from '../loader-utils';
import { createNewFormat, formatClickHandler } from '../loader-event-handlers';
import { getState } from '~src/state';
/**
 * Aggiunge i blocchi necessari per scegliere il formato
 */
export const templateAddFormats = async () => {
  const selectedProjectType = getState('selected.tipo');
  const selectedFormat = getState('selected.formato');

  const { formats } = window.editorLoader.formats[selectedProjectType.objectId];

  let htmlFormats = formats.items.reduce(
    (acc, format) => {
      if (format.isGlobal) {
        return acc;
      }
      const elementId = `format-${format.objectId}`;
      const isSelected = selectedFormat
        ? selectedFormat.objectId === format.objectId
        : false;

      const { name } = getFormatNameAndOrientration(format);

      const formatHtmlBlock = `
        <div
          id="${elementId}"
          data-format-id="${format.objectId}"
          class="${colSizes['regular']} mt-4 block-with-image ${
        isSelected ? 'block-selected' : ''
      }">
      <div class="option-button-container sidebar-context-menu-trigger bg-color-formats">
                <div class="option-button-container-relative">
                    <div class="context-menu context-menu-child sidebar-context-menu bg-color-formats color-format">
                        <div class="item context-menu-child menu-button-preferito" data-id="${
                          format.objectId
                        }">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                          </svg>
                          Preferito
                        </div>
                        <div class="item context-menu-child item--danger menu-delete-format" data-id="${
                          format.objectId
                        }" >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path>
                          </svg>
                          Elimina
                        </div>
                    </div>
                </div>
              </div>
          <div class="block-image lazy" data-bg="./assets/blocks/placeholders/format-${
            format.editor_project_formats_default_pointer?.orientation
              ? format.editor_project_formats_default_pointer.orientation
              : 's'
          }.png"></div>
          <div class="block-name">${name}</div>
        </div>`;

      acc.html = acc.html + formatHtmlBlock;
      acc.ids.push(`#${elementId}`);

      return acc;
    },
    { html: '', ids: [] }
  );

  if (formats.allowNew) {
    const newFormatHtmlBlock = `<div
        id="editor-create-new-format" title="Aggiungi formato"
        class="${colSizes['regular']} mt-4 block-with-image editor-block-new-item">
        <div class="block-image bg-color-formats lazy" data-bg="./assets/blocks/new.png"></div>
        <div class="block-name">Aggiungi formato</div>
      </div>`;

    htmlFormats.html = htmlFormats.html + newFormatHtmlBlock;

    $('body').off('click', '#editor-create-new-format');
    $('body').on('click', '#editor-create-new-format', createNewFormat);
  }

  $('#editor-formats').html(htmlFormats.html);
  if (htmlFormats.ids.length) {
    $('body').off('click', htmlFormats.ids.join(','));
    $('body').on('click', htmlFormats.ids.join(','), formatClickHandler);
  }

  window.lazyLoadInstance.update();
};
